import { render, staticRenderFns } from "./TableTeamsTypeEvents.vue?vue&type=template&id=445ca80a&scoped=true&"
import script from "./TableTeamsTypeEvents.vue?vue&type=script&lang=js&"
export * from "./TableTeamsTypeEvents.vue?vue&type=script&lang=js&"
import style0 from "./TableTeamsTypeEvents.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TableTeamsTypeEvents.vue?vue&type=style&index=1&id=445ca80a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445ca80a",
  null
  
)

export default component.exports